<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <InfoCard :infoData="this.infoDetails" :loading="this.loading" />
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="orderList">
          <div class="card-header border-0">
            <div class="d-flex align-items-center" style="text-align: left">
              <h5 class="card-title mb-0 flex-grow-1">POS Devices</h5>
              <div class="flex-shrink-0">
                <button type="button" class="btn btn-success add-btn">
                  <i class="ri-add-line align-bottom me-1"></i> Add Pos Devices
                </button>
                &nbsp;&nbsp;
                <button type="button" class="btn btn-info">
                  <i class="ri-download-line align-bottom me-1"></i> Export
                </button>
              </div>
            </div>
          </div>

          <div
            class="card-body border border-dashed border-end-0 border-start-0"
          >
            <form>
              <div class="row g-3">
                <div class="col-xxl-5 col-sm-6">
                  <div class="search-box">
                    <input
                      type="text"
                      class="form-control search"
                      v-model="search_key"
                      @keydown.enter.prevent
                      placeholder="Enter Phone Number"
                    />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </div>
                <div class="col-xxl-2 col-sm-4">
                  <div>
                    <!-- <select
                      class="form-control"
                      name="choices-single-default"
                      id="idStatus"
                    >
                      <option value="" selected>Filters</option>
                      <option
                        v-for="(option, index) in filterOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select> -->
                  </div>
                </div>
                <div class="col-xxl-2 col-sm-4">
                  <div>
                    <!-- <select
                      class="form-control"
                      name="choices-single-default"
                      id="idStatus"
                    >
                      <option value="">Sort By</option>
                      <option
                        v-for="(option, index) in sortOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select> -->
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="card-body pt-0">
            <div>
              <br />
              <br />
              <div class="table-responsive table-card mb-1">
                <div class="noresult" v-if="loading">
                  <rb-loading-table />
                </div>
                <div v-else>
                  <rb-data-table
                    title="operator"
                    :headers="headers"
            
                  />
                </div>
                <!-- <div class="d-flex justify-content-end pr-4" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="operators.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="operators.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="operators.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { posInfoDetails } from "@/constants/infodetails";
import { posHeaders } from "@/constants/headers";

export default {
  name: "PosList",
  data() {
    return {
      infoDetails: posInfoDetails,
      headers:posHeaders
    };
  },
};
</script>
